import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './core/dashboard/dashboard.component';
import { AuthGuard } from './auth/guards/auth-guard';
import { WelcomePageComponent } from './features/welcome-page/welcome-page.component';
import { FirstTimeGuard } from './auth/guards/first-time-guard';

const routes: Routes = [
  { path: 'welcome', component: WelcomePageComponent },
  {
    path: '',
    component: DashboardComponent,
    children: [
      { path: '', redirectTo: 'factory', pathMatch: 'full' },

      {
        path: '',
        loadChildren: () =>
          import('./features/features.module').then((m) => m.FeaturesModule),
      },
    ],
    canActivate: [FirstTimeGuard, AuthGuard],
  },
  { path: '**', redirectTo: '/factory', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
      scrollOffset: [0, 64],
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
